import { useState, useTransition } from "react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import { definirEtiquetasAction } from "@/web/src/acoes";

/** Etiquetas da conversa. As já usadas na clínica aparecem como sugestão. */
export function Etiquetas({ telefone, etiquetas, sugestoes }: { telefone: string; etiquetas: string[]; sugestoes: string[] }) {
  const [nova, setNova] = useState("");
  const [pendente, iniciar] = useTransition();

  const salvar = (lista: string[]) =>
    iniciar(async () => {
      const r = await definirEtiquetasAction(telefone, lista);
      if (!r.ok) toast.error(r.erro);
      else setNova("");
    });

  const faltando = sugestoes.filter((s) => !etiquetas.includes(s));

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-1.5">
        {etiquetas.map((e) => (
          <span key={e} className="flex h-6 items-center gap-1 rounded-md bg-[var(--color-painel)] pr-1 pl-2 text-xs font-medium text-[var(--color-suave)] shadow-[inset_0_0_0_1px_var(--color-borda)]">
            {e}
            <button type="button" aria-label={`Tirar ${e}`} disabled={pendente} onClick={() => salvar(etiquetas.filter((x) => x !== e))} className="rounded text-[var(--color-fraco)] hover:text-[var(--color-tinta)] disabled:opacity-40">
              <Icone nome="fechar" className="h-3 w-3" />
            </button>
          </span>
        ))}
        {etiquetas.length === 0 && <span className="text-[13px] text-[var(--color-suave)]">Nenhuma etiqueta.</span>}
      </div>

      <form
        className="flex gap-1.5"
        onSubmit={(e) => {
          e.preventDefault();
          if (nova.trim()) salvar([...etiquetas, nova]);
        }}
      >
        <input
          value={nova}
          onChange={(e) => setNova(e.target.value)}
          placeholder="nova etiqueta"
          maxLength={30}
          disabled={pendente}
          aria-label="Nova etiqueta"
          className="h-[34px] min-w-0 flex-1 rounded-[10px] border border-[var(--color-borda)] bg-[var(--color-painel)] px-3 text-[13px] text-[var(--color-tinta)] outline-none placeholder:text-[var(--color-fraco)] focus:border-[var(--color-marca)] focus:bg-[var(--color-cartao)]"
        />
        <button type="submit" disabled={pendente || !nova.trim()} className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-full bg-[var(--color-cartao)] text-[var(--color-tinta)] shadow-botao hover:bg-[var(--color-painel)] disabled:opacity-40" aria-label="Adicionar etiqueta">
          <Icone nome="mais" className="h-4 w-4" />
        </button>
      </form>

      {faltando.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {faltando.map((s) => (
            <button key={s} type="button" disabled={pendente} onClick={() => salvar([...etiquetas, s])} className="rounded-md px-1.5 py-0.5 text-xs font-medium text-[var(--color-fraco)] hover:bg-[var(--color-realce)] hover:text-[var(--color-marca-forte)] disabled:opacity-40">
              + {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
